import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// Services
import { LandingFixService } from '@shared/services/landing-fix.service';
import { PaginationService } from "./classes/paginate";
import { InstagramService } from "./services/instagram.service";
import { OrderService } from "./services/order.service";
import { ProductsService } from "./services/products.service";
import { MultiplePurchaseService } from './services/multiple-purchase.service';
import { WINDOW_PROVIDERS } from "./services/windows.service";
import { WishlistService } from "./services/wishlist.service";
// Pipes
import { OrderByPipe } from './pipes/order-by.pipe';
// components
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
// import { BsDropdownModule, ModalModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';

// import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { DateFormatterDirective } from './directives/date-formatter.directive';
import { ImageLoaderDirective } from './directives/image-loader.directive';
import { CheckoutTimerComponent } from './features/checkout-timer/checkout-timer.component';
import { LoadingOverlayComponent } from './features/loading-overlay/loading-overlay.component';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { AlfaNumericValidator } from './validators/alfanumeric.validator';
import { EmailValidator } from './validators/email.validator';
import { FiscalCodeValidator } from './validators/fiscalcode.validator';
import { PhoneNumberValidator } from './validators/phone-number.validator';
import { VatNumberValidator } from './validators/vatnumber.validator';
// import { SwiperModule } from 'swiper/angular';
// import { ProductCarouselComponent } from './features/carousel-slider/product-carousel.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { PrOverlayComponent } from './features/pr-overlay/pr-overlay.component';
import { DateFormatPipeDMY } from './pipes/date-format-d-m-y';
import { ClickOutsideDirective } from './directives/clickoutSide.directive';
import { ScrollEndDirective } from './directives/scrollend.directive';
import { EncodeTranslationPipe } from './pipes/replace-space.pipe';
import { BypassSecurity } from './pipes/bypassSecurity';
import { SplitDecimalPipe } from './pipes/decimal-font.pipe';

@NgModule({
    exports: [
        CommonModule,
        // TranslateModule,
        OrderByPipe,
        BypassSecurity,
        SplitDecimalPipe,
        LocalizedDatePipe,
        EncodeTranslationPipe,
        DateFormatPipe,
        DateFormatPipeDMY,
        NgSelectModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        BsDropdownModule,
        // VirtualScrollerModule,
        ImageLoaderDirective,
        DateFormatterDirective,
        AlfaNumericValidator,
        EmailValidator,
        VatNumberValidator,
        FiscalCodeValidator,
        LoadingOverlayComponent,
        PhoneNumberValidator,
        CheckoutTimerComponent,
        // ProductCarouselComponent,
        PrOverlayComponent,
        ClickOutsideDirective,
        ScrollEndDirective
    ],
    imports: [
        CommonModule,
        RouterModule,
        // TranslateModule,
        NgSelectModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        OrderByPipe,
        BypassSecurity,
        LocalizedDatePipe,
        SplitDecimalPipe,
        EncodeTranslationPipe,
        DateFormatPipe,
        DateFormatPipeDMY,
        ImageLoaderDirective,
        ClickOutsideDirective,
        DateFormatterDirective,
        AlfaNumericValidator,
        EmailValidator,
        VatNumberValidator,
        FiscalCodeValidator,
        LoadingOverlayComponent,
        PhoneNumberValidator,
        CheckoutTimerComponent,
        // ProductCarouselComponent,
        PrOverlayComponent,
        ScrollEndDirective,
    ],
    providers: [
        WINDOW_PROVIDERS,
        LandingFixService,
        InstagramService,
        ProductsService,
        MultiplePurchaseService,
        WishlistService,
        OrderService,
        LocalizedDatePipe,
        SplitDecimalPipe,
        EncodeTranslationPipe,
        DateFormatPipe,
        DateFormatPipeDMY,
        PaginationService,
    ]
})
export class SharedModule {
}
